<div id="user-settings-feedback" class="settings-panel">
  <header class="head">
    <div class="description">
      <div class="title">{{ panelData?.name }}</div>
      <div class="subtitle">{{ panelData?.description }}</div>
    </div>
  </header>
  <form [formGroup]="settingsForm" (submit)="submitChanges()">
    <main class="feedback-section">
      <div id="settings-panel-form">
        <div class="feedback-section-container">
          <app-user-settings-permissions-toggle
            [formGroup]="form"
            [options]="{
              setting: 'enablePostEventAction',
              titleText: ('Enable end-of-event actions' | translate),
              activeText:
                ('Hosts will be prompted to end their session when their event ends.' | translate),
              inactiveText:
                ('Hosts will be prompted to end their session when their event ends.' | translate)
            }"
          >
          </app-user-settings-permissions-toggle>
          <div
            *ngIf="form.get('settings.enablePostEventAction')?.value"
            class="end-of-event-action"
          >
            <div class="end-of-event-action-info">
              <p class="end-of-event-action-title">
                {{ 'Visibility of event timer' | translate }}
              </p>
              <p class="end-of-event-action-description">
                {{ 'Choose when to display the event countdown timer in the Top Bar.' | translate }}
              </p>
            </div>
            <div class="end-of-event-action-options">
              <app-pencil-button
                class="dropdown-toggle"
                [matMenuTriggerFor]="timerMenu"
                buttonType="button"
              >
                <p>{{ selectedTimerVisibility }}</p>
                <app-pencil-icon
                  name="keyboard_arrow_down"
                  [type]="IconTypes.matIcon"
                ></app-pencil-icon>
              </app-pencil-button>
              <mat-menu #timerMenu="matMenu">
                <button
                  *ngFor="let option of timerVisibilityOptions"
                  mat-menu-item
                  (click)="setTimerVisibility(option.value)"
                >
                  {{ option.label }}
                </button>
              </mat-menu>
            </div>
          </div>
          <app-user-settings-permissions-toggle
            *ngIf="form.get('settings.enablePostEventAction')?.value"
            [formGroup]="form"
            [options]="{
              setting: 'enableExtendEvent',
              titleText: ('Allow hosts to extend the event' | translate),
              activeText: ('Hosts will be able to extend the event.' | translate),
              inactiveText: ('Hosts will not be able to extend the event.' | translate)
            }"
          >
          </app-user-settings-permissions-toggle>
        </div>
        <ng-container *ngIf="form.get('settings.enablePostEventAction')?.value">
          <ng-container
            *ngTemplateOutlet="
              extraSettings;
              context: {
                userType: UserType.Participant,
                formGroupName: 'participantsPostEventActionMetadata',
                menuId: 'endOfEventActionMenuParticipant',
                form: settingsForm
              }
            "
          >
          </ng-container>
          <ng-container
            *ngTemplateOutlet="
              extraSettings;
              context: {
                userType: UserType.Host,
                formGroupName: 'hostsPostEventActionMetadata',
                menuId: 'endOfEventActionMenuHost',
                form: settingsForm
              }
            "
          >
          </ng-container>
        </ng-container>
      </div>
    </main>
    <div class="foot" [class.show]="formChanged$ | async">
      <app-pencil-button
        class="pencil-button primary btn-ok"
        [buttonType]="'submit'"
        [class.disabled]="form.invalid"
        [disabled]="form.invalid"
      >
        <span *ngIf="!isLoading" class="material-icons">check</span>
        <mat-spinner *ngIf="isLoading" [diameter]="24"></mat-spinner>
        <span>{{ 'Update' | translate }}</span>
      </app-pencil-button>
      <app-pencil-button
        class="pencil-button light btn-cancel"
        [buttonType]="'button'"
        (clickEvent)="cancelChanges()"
        type="button"
        icon="close"
        [iconConfig]="{ type: 'material-icon' }"
        [label]="'Cancel' | translate"
      >
      </app-pencil-button>
    </div>
  </form>
</div>

<ng-template
  #extraSettings
  let-userType="userType"
  let-formGroupName="formGroupName"
  let-menuId="menuId"
  let-form="form"
>
  <div class="extra-settings">
    <p class="extra-settings-title">{{ 'For' | translate }} {{ userTypeLabels[userType] }}</p>
    <div class="feedback-section-container">
      <div class="end-of-event-action">
        <div class="end-of-event-action-info">
          <p class="end-of-event-action-title">{{ 'End-of-event action' | translate }}</p>
          <p class="end-of-event-action-description">
            {{ 'User is redirected to an external site' | translate }}
          </p>
        </div>
        <div class="end-of-event-action-options">
          <app-pencil-button class="dropdown-toggle" [matMenuTriggerFor]="menu" buttonType="button">
            <p>{{ userType === UserType.Host ? selectedHostAction : selectedParticipantAction }}</p>
            <app-pencil-icon
              name="keyboard_arrow_down"
              [type]="IconTypes.matIcon"
            ></app-pencil-icon>
          </app-pencil-button>
          <mat-menu #menu="matMenu" [id]="menuId">
            <button
              mat-menu-item
              *ngFor="let action of endOfEventActions"
              (click)="selectEndOfEventAction(action, userType)"
            >
              {{ action.name }}
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
    <div class="feedback-section-container configure-survey-container" [formGroup]="form">
      <div class="configure-survey-header">
        <p class="end-of-event-action-title">{{ 'Configure session survey' | translate }}</p>
        <p class="end-of-event-action-description">
          {{ 'Set session survey URL and configure how data is passed to the survey' | translate }}
        </p>
      </div>
      <div class="configure-survey-body" [formGroupName]="formGroupName">
        <div class="configure-survey-body-item">
          <p class="subtitle-section">{{ 'Survey URL' | translate }}</p>
          <input
            type="text"
            formControlName="url"
            class="survey-url-input"
            placeholder="https://..."
            [class.invalid-input]="
              settingsForm?.get(formGroupName)?.get('url')?.invalid &&
              settingsForm?.get(formGroupName)?.get('url')?.touched
            "
          />
          <p class="error-text">
            <span
              *ngIf="
              settingsForm?.get(formGroupName)?.get('url')?.errors?.['required'] &&
              settingsForm?.get(formGroupName)?.get('url')?.touched
              "
            >
              {{ 'This field is required.' | translate }}
            </span>
            <span
              *ngIf="
              settingsForm?.get(formGroupName)?.get('url')?.errors?.['pattern'] &&
              settingsForm?.get(formGroupName)?.get('url')?.touched
              "
            >
              {{ 'Invalid URL.' | translate }}
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</ng-template>
